module.exports = __webpack_public_path__ + "img/icon-about@2x.14bb1806.png";